export default {
  COURSE: "course",
  MODULE: "module",
  EVENT: "event",
  SLAVE: "slave",
  MANUAL: "manual",
};
